import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

interface CandidateProfileTagProps {
  tagText: string;
  backgroundColor?: BadgeLayoutProps['color'];
}

const CandidateProfileTag = ({ tagText, backgroundColor = 'default' }: CandidateProfileTagProps) => {
  return <Badge color={backgroundColor}>{tagText}</Badge>;
};

export default CandidateProfileTag;
